<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<section class="resend-section">
  <div class="container">
    <div class="resend-container">
      <div class="resend-card">
        <div class="resend-header">
          <h1 class="resend-title">{{ "page.registration.resend.title" | translate }}</h1>
          <p class="resend-subtitle">{{ "page.registration.resend.emailDescription" | translate }}</p>
        </div>

        <!-- Email Form -->
        <form [formGroup]="emailForm" (ngSubmit)="onSubmit()" class="email-form">
          <!-- Email Field -->
          <div class="form-group">
            <label for="email" class="form-label">{{ "form.email" | translate }}</label>
            <div class="email-input-wrapper">
              <input type="email" id="email" formControlName="email" class="form-input" autocomplete="email" />
              <div class="error-message" *ngIf="emailForm.controls.email.touched && emailForm.controls.email.errors?.['required']">
                <span>{{ "page.login.error.required" | translate }} </span>
              </div>
              <div class="error-message" *ngIf="emailForm.controls.email.touched && emailForm.controls.email.errors?.['pattern']">
                <span>{{ "page.login.error.email" | translate }} </span>
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="form-buttons">
            <button type="button" class="button color-gray" (click)="close()">
              {{ "button.cancel" | translate }}
            </button>
            <button type="submit" class="button color-blue" [disabled]="emailForm.disabled">
              {{ "button.resend" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
